import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Axios, { AxiosResponse } from 'axios';
import { SiteRegister } from '../../../types/ServerRequests';
import { Actions } from '../LoginPage';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
// import LoginServices from '../../../services/LoginServices';

interface Props {
    actionHandler: (action: Actions) => void;
}

interface State {
    pseudo: string;
    emailInfo: string;
    passwordInfo: string;
    confirmPassWordInfo: string;
    loading: boolean;
}

/**
 *
 */
export class FormRegister extends React.Component {

    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            pseudo: '',
            emailInfo: '',
            passwordInfo: '',
            confirmPassWordInfo: '',
            loading: false,
        };
    }

    handleSubmit = () => {
        if (this.state.pseudo === '') {
            alert('Entrer un pseudonyme');
        } else if (this.state.emailInfo === '') {
            alert('Entrer un email');
        } else if (this.state.passwordInfo === '') {
            alert('Entrer un mot de passe');
        } else if (this.state.confirmPassWordInfo === '') {
            alert('Confirmer votre mot de passe');
        } else {
            if (this.state.passwordInfo !== this.state.confirmPassWordInfo) {
                alert('Les deux mot de passe sont différents');
            } else {
                // const loginServices = LoginServices.getInstance();
                // loginServices.subscribe(this.state.pseudo, this.state.emailInfo, this.state.passwordInfo);
                this.setState({loading: true});
                return (Axios.post(
                    process.env.REACT_APP_REGISTER_URL!,
                    {
                        username: this.state.pseudo,
                        email: this.state.emailInfo,
                        password: this.state.passwordInfo
                    }
                ).then(
                    (response: AxiosResponse<SiteRegister>) => {
                        // alert('Votre email est : ' + response.data.data.email);
                        this.props.actionHandler(Actions.LOGIN);
                    }
                ).catch(
                    (error) => {
                        this.setState({loading: false});
                        alert(
                            error.response.data.errors.email + '\n' + error.response.data.errors.password + '\n'
                        );
                    }
                ));
            }
        }
        return Promise.reject('');
    }

    DisplayForm = () => {
        return (
            <div>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Nom d'utilisateur"
                        value={this.state.pseudo}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ pseudo: e.target.value });
                            }
                        }
                        onKeyPress={
                            (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter') {
                                    this.handleSubmit();
                                }
                            }
                        }
                        name="username"
                        type="text"
                    />
                </div>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="E-mail"
                        value={this.state.emailInfo}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ emailInfo: e.target.value });
                            }
                        }
                        onKeyPress={
                            (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter') {
                                    this.handleSubmit();
                                }
                            }
                        }
                        name="email"
                        type="email"
                    />
                </div>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Mot de passe"
                        value={this.state.passwordInfo}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ passwordInfo: e.target.value });
                            }
                        }
                        onKeyPress={
                            (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter') {
                                    this.handleSubmit();
                                }
                            }
                        }
                        name="password"
                        type="password"
                    />
                </div>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Confirmation mot de passe"
                        value={this.state.confirmPassWordInfo}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ confirmPassWordInfo: e.target.value });
                            }
                        }
                        onKeyPress={
                            (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter') {
                                    this.handleSubmit();
                                }
                            }
                        }
                        name="password"
                        type="password"
                    />
                </div>
            </div>
        );
    }

    DisplayButtonForm = () => {
        return (
            <div >
                <LoaderButton
                    onClick={this.handleSubmit}
                    className="col-12 btn btn-lg"
                    load={this.state.loading}
                >
                    Valider
                </LoaderButton>
            </div>
        );
    }

    render() {
        return (
            <div className="col-12 ">
                <this.DisplayForm />
                <this.DisplayButtonForm />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage/internalComponents/FormRegister.tsx